<ng-container *ngIf="isDataExist then showNominatedFamilyProviders else emptyTable"></ng-container>

<!---------------------------->
<!-- Nominated Family Provides Details:-->
<!---------------------------->
<ng-template #showNominatedFamilyProviders>
  <ng-container *ngFor="let person of personList;">
    <h3>{{ person.firstName }} {{ person.lastName }}</h3>
    <div class="mat-elevation-z8 table-container">
      <table [dataSource]="person.nominatedFamilyProviders" mat-table>

        <ng-container [matColumnDef]="tableColumns.Order">
          <th *matHeaderCellDef mat-header-cell>Order</th>
          <td *matCellDef="let row; let i = index" mat-cell>{{ i + 1 }}</td>
        </ng-container>

        <ng-container [matColumnDef]="tableColumns.ProviderCode">
          <th *matHeaderCellDef mat-header-cell>Provider Number</th>
          <td *matCellDef="let familyProvider" mat-cell>{{familyProvider[tableColumns.ProviderCode]}}</td>
        </ng-container>

        <ng-container [matColumnDef]="tableColumns.ProviderName">
          <th *matHeaderCellDef mat-header-cell>Provider Name</th>
          <td *matCellDef="let familyProvider" mat-cell>{{familyProvider[tableColumns.ProviderName]}}</td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
      </table>
    </div>
  </ng-container>
</ng-template>

<ng-template #emptyTable>
  <div class="text-center">
    <label class="column-label">No family providers specified</label>
  </div>
</ng-template>
